import React, { Component } from "react";
import LocalizedStrings from "react-localization";
import en from "../../../localization/localization-en.json";

let strings = new LocalizedStrings({ en });

class SettingSendText extends Component {
  state = { send_text: true };

  constructor(props) {
    super(props);
    this.state = {
      send_text: props.user.send_text
    };
  }

  render() {
    return (
      <div className="max_width_500 pb-2 pt-2">
        <label className="name pb-2">{strings.yaystack_text}</label>
        <label className="switchOnOff">
          <input
            type="checkbox"
            className=""
            defaultChecked={this.state.send_text}
            value={this.state.send_text}
            ischecked={this.state.send_text.toString()}
            onChange={this.handleChangeSendText}
          />
          <span className="slider round" />
        </label>
      </div>
    );
  }

  handleChangeSendText = event => {
    var send_text = !this.state.send_text;
    this.setState({ send_text });
    var fd = new FormData();
    fd.append("user[send_text]", send_text);
    this.props.handlerUpdateUser(fd);
  };
}

export default SettingSendText;



// WEBPACK FOOTER //
// ./src/components/profile/modal/settings_send_text.jsx